import { UntypedFormBuilder } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { SearchAudanetTasksType } from "./SearchAudanetTasksType";

export interface SearchAudanetTasksCriteria {
    maxCount: number;
    startIndex: number;
    fieldsToReturn: string;
    claimNumber: string;
    plateNumber: string;
    vin: string;

    searchType: number;
}


export class SearchAudanetTasksCriteriaFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, searchCriteria: SearchAudanetTasksCriteria) {

        return fb.group(
            {
                searchType: [searchCriteria.searchType],
                claimNumber: [searchCriteria.claimNumber],
                plateNumber: [searchCriteria.plateNumber],
                vin: [searchCriteria.vin],
            }
        );
    }

    static initSearchAudanetTasksCriteria(claimNumber: string, plateNumber:string,vin:string): SearchAudanetTasksCriteria {
        const result: SearchAudanetTasksCriteria = {
            claimNumber: claimNumber,
            plateNumber: plateNumber,
            vin: vin,
            maxCount: 10,
            startIndex: 1,
            fieldsToReturn: '',
            searchType: SearchAudanetTasksType.ClaimNumber
        };

        result.searchType = SearchAudanetTasksCriteriaFormBuilder.setInitSearchType(result);

        return result;
    }

    static setInitSearchType(searchCriteria: SearchAudanetTasksCriteria): number{
        
        if(searchCriteria?.plateNumber){
            return SearchAudanetTasksType.ClaimNumber;
        }

        if(searchCriteria?.vin){
            return SearchAudanetTasksType.VIN;

        }

        if(searchCriteria?.claimNumber){
            return SearchAudanetTasksType.ClaimNumber;
        }

        
    }
}